<div class="p-15">
    <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
            <h1 mat-dialog-title style="color: var(--mat-primary-color)">COLUMNS</h1>
            <button mat-icon-button (click)="toggleAll()" style="margin-top: 8px; margin-left: -20px">
                <mat-icon>visibility</mat-icon>
            </button>
        </div>
        <div>
            @if (data.hasPresetFilters) {
                <div style="display: flex; padding-right: 20px">
                    @if (data.presetFilter) {
                        <div style="font-size: large; font-weight: 500; margin-top: 16px">{{ data.presetFilter.name }}</div>
                        @if (isCamo && data.presetFilter?.type === 1) {
                            <button mat-icon-button (click)="deleteFilterPreset()"><mat-icon>delete</mat-icon></button>
                        }
                    }
                    @if (isCamo && (!data.presetFilter || data.presetFilter?.type === 1)) {
                        <button mat-raised-button color="primary" style="margin: 10px" (click)="saveFilterPreset()">Save Filter</button>
                    }
                </div>
            }
        </div>
    </div>
    <div mat-dialog-content>
        @for (group of data.gridColumns; track group.id) {
            <hr />
            <div fxLayout="row" fxLayoutAlign="start center">
                <h2 class="m-0 mr-5">{{ getColumnTitleById(group.id) }}</h2>
                @if (group.columns.length > 1) {
                    <button mat-icon-button (click)="toggleGroup(group.id)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                }
            </div>
            @if (!group.groupedColumns) {
                <div>
                    @for (c of group.columns; track c.def) {
                        @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                            <mat-checkbox (click)="onCheckboxToggle(c)" [checked]="!c.hidden">
                                {{ c.label }}
                            </mat-checkbox>
                        }
                    }
                </div>
            } @else {
                @for (subgroup of group.groupedColumns; track subgroup.id.toString()) {
                    @if (subgroup.id | isNumber) {
                        <hr />
                        <div>
                            @for (c of subgroup.columns; track c.def) {
                                @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                    <mat-checkbox (click)="onCheckboxToggle(c)" [checked]="!c.hidden">
                                        {{ c.label }}
                                    </mat-checkbox>
                                }
                            }
                        </div>
                        <hr />
                    } @else if (!hideSubgroupBasedOnHelicopterData(subgroup.id)) {
                        <div style="display: flex; align-items: center">
                            <h3 class="m-0 pl-10">&#8627; {{ getColumnTitleById(subgroup.id) }}</h3>
                            <div class="pl-10">
                                @for (c of subgroup.columns; track c.def) {
                                    @if (!hideColumnsBasedOnHelicopterData(c.def)) {
                                        <mat-checkbox (click)="onCheckboxToggle(c)" [checked]="!c.hidden">
                                            {{ c.label }}
                                        </mat-checkbox>
                                    }
                                }
                            </div>
                        </div>
                    }
                }
            }
        }
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="onClose()">Close</button>
    </div>
</div>
